var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicalEvaluation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 230,
    viewBox: "0 0 231 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4673_12716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.41992 79.6299V12.4492C3.41992 7.44043 7.48535 3.375 12.4941 3.375H148.477C153.486 3.375 157.551 7.44043 157.551 12.4492V55.0711",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41992 95.3984V199.168C3.41992 204.181 7.48535 208.247 12.4941 208.247H151.653",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3291 54.5195H62.5611C68.5761 54.5195 73.4519 59.3953 73.4519 65.4104V87.512",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3291 54.5198H62.5611C68.5761 54.5198 73.4519 49.6439 73.4519 43.6289V21.5273",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3213 54.5186C55.3213 53.0667 55.0351 51.6822 54.5208 50.4154C57.186 47.8283 58.8643 44.2301 58.9289 40.2383C59.0606 32.1205 52.2648 25.4766 44.1461 25.4766C29.9957 25.4766 18.5244 36.9478 18.5244 51.0982V57.9394C18.5244 72.0897 29.9957 83.561 44.1461 83.561C52.2648 83.561 59.061 76.9171 58.9289 68.7992C58.8638 64.807 57.186 61.2092 54.5208 58.6222C55.0351 57.3549 55.3213 55.9704 55.3213 54.5186Z",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.642 54.5195H98.4099C92.3949 54.5195 87.519 59.3954 87.519 65.4104V87.512",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.642 54.5198H98.4099C92.3949 54.5198 87.519 49.6439 87.519 43.6289V21.5273",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.373 59.8917C142.423 59.2475 142.446 58.5939 142.446 57.9358V51.0973C142.446 44.023 139.578 37.6154 134.94 32.9821C130.307 28.3444 123.9 25.4766 116.825 25.4766C108.707 25.4766 101.909 32.1201 102.041 40.2383C102.109 44.227 103.783 47.8256 106.452 50.4122C105.934 51.6826 105.649 53.0667 105.649 54.519C105.649 55.9713 105.934 57.3554 106.452 58.6213C103.783 61.2079 102.109 64.8066 102.041 68.7997C102.041 68.8769 102.041 68.9537 102.041 69.031C102.041 76.9903 108.693 83.4747 116.667 83.561",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.552 201.224V186.703",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.334 186.703V201.224",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.464 62.2537C214.943 72.4914 226.682 91.4709 226.682 113.191C226.682 145.772 200.272 172.182 167.69 172.182C135.108 172.182 108.699 145.772 108.699 113.191C108.699 80.6088 135.108 54.1992 167.69 54.1992C172.955 54.1992 178.063 54.891 182.923 56.1848",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.288 152.649C150.382 157.056 158.746 159.599 167.69 159.599C193.278 159.599 214.094 138.778 214.094 113.19C214.094 87.6025 193.278 66.7812 167.69 66.7812C142.103 66.7812 121.281 87.6025 121.281 113.19C121.281 124.173 125.118 134.276 131.514 142.232",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.653 226.635V205.761C151.653 203.254 153.685 201.223 156.191 201.223H180.696C183.202 201.223 185.234 203.254 185.234 205.761V226.635",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.233 169.898V182.164C185.233 184.669 183.2 186.702 180.695 186.702H156.191C153.686 186.702 151.653 184.669 151.653 182.164V170.28",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.834 135.465C159.744 135.465 157.653 134.668 156.059 133.072L143.191 120.205C140.001 117.015 140.001 111.844 143.191 108.654C146.381 105.464 151.553 105.463 154.743 108.654L161.835 115.745L180.637 96.9435C183.827 93.7532 188.999 93.7532 192.188 96.9435C195.378 100.133 195.378 105.305 192.188 108.495L167.61 133.073C166.015 134.668 163.925 135.465 161.834 135.465Z",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4148 120.212H22.1546C20.1497 120.212 18.5244 118.587 18.5244 116.582V109.322C18.5244 107.317 20.1497 105.691 22.1546 105.691H29.4153C31.4201 105.691 33.0454 107.317 33.0454 109.322V116.582C33.0454 118.587 31.4201 120.212 29.4148 120.212Z",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5664 105.691H94.1769",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9327 120.211H47.5664",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4148 155.15H22.1546C20.1497 155.15 18.5244 153.525 18.5244 151.52V144.259C18.5244 142.254 20.1497 140.629 22.1546 140.629H29.4153C31.4201 140.629 33.0454 142.254 33.0454 144.259V151.52C33.0454 153.525 31.4201 155.15 29.4148 155.15Z",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5664 140.629H94.1769",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9327 155.148H47.5664",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4148 190.091H22.1546C20.1497 190.091 18.5244 188.466 18.5244 186.461V179.2C18.5244 177.196 20.1497 175.57 22.1546 175.57H29.4153C31.4201 175.57 33.0454 177.196 33.0454 179.2V186.461C33.0454 188.466 31.4201 190.091 29.4148 190.091Z",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5664 175.57H94.1769",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9327 190.09H47.5664",
    stroke: "#7f56d9",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4673_12716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 230,
    fill: "white",
    transform: "translate(0.0507812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalEvaluation);
export default __webpack_public_path__ + "static/media/clinicalEvaluation.32bcfc23cd960ca48cf9f1d9ddf0d692.svg";
export { ForwardRef as ReactComponent };